import { render, staticRenderFns } from "./EditGithubRepoSidePanel.vue?vue&type=template&id=6ef17581&"
import script from "./EditGithubRepoSidePanel.vue?vue&type=script&lang=ts&"
export * from "./EditGithubRepoSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports